import React, { Fragment, useState, useEffect } from 'react'
import { CDBBtn } from "cdbreact";
import buttonArow from '../assets/images/button-arrow-hover.svg'
import buttonArowWhite from '../assets/images/button-arrow.svg'
import shieldStar from '../assets/images/shield-star.svg'
import { Form } from 'react-bootstrap'
import { Formik } from 'formik';
import * as Yup from 'yup';
import { GET_RESULT, LOCATION_URL, GET_VEHICLE_MAKES, GET_VEHICLE_MODELS } from '../api/constant';
import { Toaster, toast } from 'react-hot-toast';
import { useDispatch } from 'react-redux'
import { storeResult, storeUserInfo } from '../store/resultSlice'
import Autocomplete from '@mui/material/Autocomplete';


import TextField from "@mui/material/TextField";
import DatePicker from "../component/DatePicker"
import FormHelperText from "@mui/material/FormHelperText";

import "react-datepicker/dist/react-datepicker.css";
import { Link, useNavigate } from 'react-router-dom';

const selectFields = []
const StepperForm = ({ pageSlug, handleNextPrevClick, step, stepIndex, catID, totalStep }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validationRules = {}
  const checkboxFields = []
  const dateFields = []

  // console.log("Step from form", step);
  step.forEach((item) => {
    if (item.field_type === 'Checkbox') {
      if (item.is_require == 1) {
        validationRules[item.column_name] = Yup.array().min(1, "Required").required('Required')
      } else {
        validationRules[item.column_name] = Yup.array();
      }
      checkboxFields.push(item.column_name)
    } else if (item.field_type === 'Date') {
      if (item.is_require == 1) {
        validationRules[item.column_name] = Yup.date().required('Required')
      } else {
        validationRules[item.column_name] = Yup.date()
      }
      dateFields.push(item.column_name)
    } else if (item.field_type === 'Dropdown Selection') {
      if (item.is_require == 1) {
        validationRules[item.column_name] = Yup.string().required('Required').notOneOf([`Select ${item.element_name} Option`], 'default value is not allowed')
      } else {
        validationRules[item.column_name] = Yup.string()
      }
      selectFields.push(item.column_name)
    } else {
      if (item.is_require == 1) {
        if (item.validation_type == 'email') {
          validationRules[item.column_name] = Yup.string().email().required('Required')
        } else if (item.validation_type == 'numeric') {
          validationRules[item.column_name] = Yup.string().required('Required').matches(/^[0-9]+$/, 'Only numbers are allowed').max(15, 'Maximum 15 characters allowed')
        } else if (item.validation_type == 'alpha') {
          validationRules[item.column_name] = Yup.string().required('Required').matches(/^[a-zA-Z]*$/, 'Only alphabetic characters are allowed')
        } else if (item.validation_type == 'alpha_mumeric') {
          validationRules[item.column_name] = Yup.string().required('Required').matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters are allowed')
        } else {
          validationRules[item.column_name] = Yup.string().required('Required')
        }
      } else {
        if (item.validation_type == 'email') {
          validationRules[item.column_name] = Yup.string().email()
        } else if (item.validation_type == 'numeric') {
          validationRules[item.column_name] = Yup.string().matches(/^[0-9]+$/, 'Only numbers are allowed').max(15, 'Maximum 15 characters allowed')
        } else if (item.validation_type == 'alpha') {
          validationRules[item.column_name] = Yup.string().matches(/^[a-zA-Z]*$/, 'Only alphabetic characters are allowed')
        } else if (item.validation_type == 'alpha_mumeric') {
          validationRules[item.column_name] = Yup.string().matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters are allowed')
        } else {
          validationRules[item.column_name] = Yup.string()
        }
      }
    }

  })
  const validationSchema = Yup.object().shape(validationRules)
  const test = Object.keys(validationRules).reduce((acc, key) => {
    if (checkboxFields.includes(key)) {
      acc[key] = []
    } else if (dateFields.includes(key)) {
      const currentDate = new Date();
      acc[key] = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
    } else {
      acc[key] = '';
    }
    return acc;
  }, {})


  const dynamicWidth = 100 / totalStep;
  var temp = document.querySelectorAll(".step-content .steps");
  for (var i = 0; i < temp.length; i++) {
    temp[i].style.width = dynamicWidth + "%";
  }
  // console.log("validationRules", validationRules);
  // console.log("test", test);
  return (
    <div className="StepContainer">
      <div className="FlexColumnContainer">
        <Toaster
          position="top-center"
          reverseOrder={false}
          duration="50000"
        />
        <Formik
          initialValues={test}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            // console.log('value init',values);
            // Submit Data
            if (stepIndex === 1) {
              localStorage.removeItem("requestBody");
            }

            let storageBody = {};
            if (stepIndex > 1) {
              storageBody = JSON.parse(localStorage.getItem('requestBody'));
              values = { ...storageBody, ...values }

              // console.log('value update',values);
            }

            const requestBody = {
              sub_category_id: catID,
              isfinal: stepIndex === totalStep ? 1 : 0,
              step: stepIndex,
              ...values
            }

            localStorage.setItem('requestBody', JSON.stringify(values));

            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(requestBody)
            };
            const res = await fetch(GET_RESULT, requestOptions);
            const data = await res.json()
            if (data.status) {
              handleNextPrevClick(stepIndex + 1)
              if (stepIndex === totalStep) {
                // console.log("data",data);
                dispatch(storeResult(data.data.result))
                dispatch(storeUserInfo(data.data.userinfo))
                navigate('/result')
                localStorage.removeItem("requestBody");
              }
            } else {
              toast.error(data.message);
            }

          }}
        >
          {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (<Form className={`step-${stepIndex}-${pageSlug}`} name={`step-${stepIndex}-${pageSlug}`} onSubmit={handleSubmit}>

            {step.map((item, index) => {
              const stepToDisplay = item
              return <Fragment key={item.field_id + index}>{(ComponentMapping[item.field_types_id])(stepToDisplay, errors, handleChange, values, setFieldValue)}</Fragment>
            })}

            <div className="d-flex justify-content-start align-items-center w-full btn-information-group">

              <Link type="submit" className={`cutom-button mt-0 btn-${stepIndex}-${pageSlug}`} onClick={handleSubmit} onSubmit={handleSubmit} >
                {stepIndex === totalStep ? 'Finish' : 'Continue'} <img className='on-hover' src={buttonArow} alt="" /> <img className='defailt' src={buttonArowWhite} alt="" />
              </Link>
              <p className='information-tag m-0'> <img className='defailt' src={shieldStar} alt="" />  We don't sell your personal information to third parties </p>
            </div>
          </Form>
          )}
        </Formik>
      </div>

    </div>
  );
};

const InputBox = (props, errors, handleChange, values) => {

  return <Form.Group className="mb-3 form-group" controlId={props.field_id}>
    <Form.Label>{props.element_name}<span className={(props.is_require == 1 ? 'required' : 'optional')}>*</span></Form.Label>
    <Form.Control type="text" name={props.column_name} value={values.column_name} onChange={handleChange} isInvalid={!!errors[props.column_name]} />
    <Form.Control.Feedback type="invalid">
      {props.element_name} is {errors[props.column_name]}
    </Form.Control.Feedback>
  </Form.Group>
}
const RadioBoxField = (props, errors, handleChange, values) => {
  return <Form.Group className="mb-3 form-group">

    <Form.Label>{props.element_name}<span className={(props.is_require == 1 ? 'required' : 'optional')}>*</span></Form.Label>
    <div className='input-btn-group'>
      {Object.entries(props.option_values).map((option, index) => {
        // console.log('option',option[0]);
        return <React.Fragment key={props.field_id + index}>
          {/* <input id={option[1]} name='radio' type="radio" /> */}
          <Form.Check type="radio" name={props.column_name} onChange={handleChange} isInvalid={!!errors[props.column_name]} value={option[0]} label={option[1]} />
        </React.Fragment>
      })}
    </div>
    <FormHelperText>{errors[props.column_name]
      ? `${props.element_name} is ` + errors[props.column_name]
      : ''}</FormHelperText>

  </Form.Group>;
}

const CheckBoxField = (props, errors, handleChange, values, setFieldValue) => {
  const selectedValues = values[props.column_name] || [];
  const [noneSelected, setNoneSelected] = useState(false);

  const onCheckboxChange = (value, label, checked) => {
    const isNone = label.toLowerCase().includes("none");
    let newValues = [...selectedValues];

    if (isNone) {
      // User clicked None → visually check None, deselect others
      setNoneSelected(checked);
      // Clear all other selections
      newValues = [];
    } else {
      // User clicked a real option → deselect None visually
      setNoneSelected(false);

      // Remove None from values if it somehow exists (shouldn't)
      newValues = newValues.filter((val) => {
        const labelVal = props.option_values[val];
        return !labelVal?.toLowerCase().includes("none");
      });

      if (checked) {
        newValues.push(value);
      } else {
        newValues = newValues.filter((v) => v !== value);
      }
    }

    setFieldValue(props.column_name, newValues);
  };

  return (
    <Form.Group className="mb-3 form-group">
      <Form.Label>
        {props.element_name}
        <span className={props.is_require === 1 ? "required" : "optional"}>*</span>
      </Form.Label>

      <div className="input-btn-group">
        {Object.entries(props.option_values).map(([value, label], index) => {
          const isNone = label.toLowerCase().includes("none");
          const isChecked = isNone ? noneSelected : selectedValues.includes(value);

          return (
            <Form.Check
              key={props.field_id + index}
              type="checkbox"
              name={props.column_name}
              value={value}
              label={label}
              isInvalid={!!errors[props.column_name]}
              checked={isChecked}
              onChange={(e) => onCheckboxChange(value, label, e.target.checked)}
            />
          );
        })}
      </div>

      <FormHelperText>
        {errors[props.column_name]
          ? `${props.element_name} is ${errors[props.column_name]}`
          : ""}
      </FormHelperText>
    </Form.Group>
  );
};

// ...existing code...
let zipcodesCache = [];
let citiesCache = [];
let vehicleMakeCache = [];
let modelsCache = [];

//vehicle_makes
const resMakes = await fetch(GET_VEHICLE_MAKES);
const jsonMakes = await resMakes.json();
const vehicle_makes = Object.values(jsonMakes.data);
vehicleMakeCache = vehicle_makes

//Years
const vehicleYears = Array.from({ length: new Date().getFullYear() - 1980 + 1 }, (_, i) => new Date().getFullYear() - i);


// Dropdowns.
const DropDownField = (props, errors, handleChange, values, setFieldValue) => {
  const OPTIONS_LIMIT = 1000;
  const options = Object.entries(props.option_values || {}).map(([value, label]) => ({ value, label }));
  const [localOptions, setLocalOptions] = useState(options);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.column_name === 'zip_code') { //ZIP CODE
      setLocalOptions(zipcodesCache.map(z => ({ value: String(z), label: String(z) })));
      const handler = (e) => {
        const data = e.detail || [];
        setLocalOptions(data.map(z => ({ value: String(z), label: String(z) })));
      };
      window.addEventListener('zipcodesUpdated', handler);
      return () => window.removeEventListener('zipcodesUpdated', handler);
    } else if (props.column_name === 'city') { //CITY
      setLocalOptions(citiesCache.map(c => ({ value: String(c), label: String(c) })));
      const handler = (e) => {
        const data = e.detail || [];
        setLocalOptions(data.map(c => ({ value: String(c), label: String(c) })));
      };
      window.addEventListener('citiesUpdated', handler);
      return () => window.removeEventListener('citiesUpdated', handler);
    } else if (props.column_name === 'vichical_make') { //VEHICLE MAE
      setLocalOptions(vehicleMakeCache.map(c => ({ value: String(c), label: String(c) })));
      const handler = (e) => {
        const data = e.detail || [];
        setLocalOptions(data.map(c => ({ value: String(c), label: String(c) })));
      };
      window.addEventListener('vehiclesUpdated', handler);
      return () => window.removeEventListener('vehiclesUpdated', handler);
    } else if (props.column_name === 'vehicle_model') { //MODELS
      setLocalOptions(modelsCache.map(c => ({ value: String(c), label: String(c) })));
      const handler = (e) => {
        const data = e.detail || [];
        setLocalOptions(data.map(c => ({ value: String(c), label: String(c) })));
      };
      window.addEventListener('modelsUpdated', handler);
      return () => window.removeEventListener('modelsUpdated', handler);
    } else if (props.column_name === 'min_vehicle_year') { //VEHICLE YEARS
      setLocalOptions(vehicleYears.map(c => ({ value: String(c), label: String(c) })));
      const handler = (e) => {
        const data = e.detail || [];
        setLocalOptions(data.map(c => ({ value: String(c), label: String(c) })));
      };
      window.addEventListener('yearsUpdated', handler);
      return () => window.removeEventListener('yearsUpdated', handler);
    } else {
      setLocalOptions(options);
    }
  }, [props.column_name, props.option_values]); // eslint-disable-line

  const filterOptions = (optionsList, { inputValue = '' }) => {
    const q = inputValue || '';
    return optionsList
      .filter(option => (option.label || '').startsWith(q))
      .slice(0, OPTIONS_LIMIT);
  };

  const onSelectChange = async (event, newValue) => {
    const selectedValue = newValue && newValue.value !== undefined ? newValue.value : "";
    setFieldValue(props.column_name, selectedValue);


    // If state changed -> clear city and zip, fetch cities for state
    if (props.column_name === 'state') {
      // clear dependent fields immediately
      setFieldValue('city', '');
      setFieldValue('zip_code', '');
      citiesCache = [];
      zipcodesCache = [];
      window.dispatchEvent(new CustomEvent('citiesUpdated', { detail: [] }));
      window.dispatchEvent(new CustomEvent('zipcodesUpdated', { detail: [] }));

      if (!selectedValue) return;

      try {
        setLoading(true);
        // adjust endpoint if needed: expected to return array or { data: [...] }
        const res = await fetch(`${LOCATION_URL}/cities/${selectedValue}`);
        const json = await res.json();
        const cities = Object.values(json.option_values);
        citiesCache = cities;
        window.dispatchEvent(new CustomEvent('citiesUpdated', { detail: cities }));

        if (!selectFields.includes('city')) {
          const resZip = await fetch(`${LOCATION_URL}/zipcodes/${selectedValue}`);
          const jsonZip = await resZip.json();
          const zipcodes = Object.values(jsonZip.option_values);
          zipcodesCache = zipcodes;
          window.dispatchEvent(new CustomEvent('zipcodesUpdated', { detail: zipcodes }));
        }



      } catch (err) {
        citiesCache = [];
        window.dispatchEvent(new CustomEvent('citiesUpdated', { detail: [] }));
        console.error('Failed to fetch cities', err);
      } finally {
        setLoading(false);
      }
    }

    // If city changed -> clear zip, fetch zips for city (use state if available)
    // ...existing code inside onSelectChange for props.column_name === 'city' ...
    if (props.column_name === 'city') {
      setFieldValue('zip_code', '');
      zipcodesCache = [];
      window.dispatchEvent(new CustomEvent('zipcodesUpdated', { detail: [] }));

      if (!selectedValue) return;

      try {
        setLoading(true);
        const stateVal = values['state'] || '';

        // prefer endpoint that takes both state and city if state is available
        let url;
        if (stateVal) {
          // backend: /zipcodes/{state}/{city}  (adjust if your API uses a different path)
          url = `${LOCATION_URL}/zipcodes/${encodeURIComponent(stateVal)}/${encodeURIComponent(selectedValue)}`;
        } else {
          // fallback: city-only lookup
          url = `${LOCATION_URL}/zipcodes/city/${encodeURIComponent(selectedValue)}`;
        }

        const res = await fetch(url);
        const json = await res.json();
        const zips = Array.isArray(json) ? json : (json && json.data ? json.data : Object.values(json.option_values || {}));
        zipcodesCache = zips;
        window.dispatchEvent(new CustomEvent('zipcodesUpdated', { detail: zips }));
      } catch (err) {
        zipcodesCache = [];
        window.dispatchEvent(new CustomEvent('zipcodesUpdated', { detail: [] }));
        console.error('Failed to fetch zip codes for city', err);
      } finally {
        setLoading(false);
      }
    }

    //Get vehicle models
    if (props.column_name === 'vichical_make') {
      setFieldValue('vehicle_model', '');
      modelsCache = [];
      window.dispatchEvent(new CustomEvent('modelsUpdated', { detail: [] }));
      if (!selectedValue) return;

      try {
        setLoading(true);

        let url = `${GET_VEHICLE_MODELS}/${encodeURIComponent(selectedValue)}`;

        const res = await fetch(url);
        const json = await res.json();
        const models = Array.isArray(json) ? json : (json && json.data ? json.data : Object.values(json.data || {}));
        modelsCache = models;
        window.dispatchEvent(new CustomEvent('modelsUpdated', { detail: models }));
      } catch (err) {
        modelsCache = [];
        window.dispatchEvent(new CustomEvent('modelsUpdated', { detail: [] }));
        console.error('Failed to fetch models', err);
      } finally {
        setLoading(false);
      }
    }

  };

  const renderOptions = props.column_name === 'zip_code' || props.column_name === 'city' ? localOptions : localOptions;

  // control selected value from Formik so changing state/city clears dependent selections immediately
  const currentValue = values[props.column_name];
  const selectedOption = renderOptions.find(o => String(o.value) === String(currentValue)) || null;

  return (
    <Form.Group className={(props.is_require == 1 ? 'mb-3 form-group auto-required' : 'mb-3 form-group auto-optional')}>
      <Autocomplete
        aria-label={props.element_name}
        name={props.column_name}
        options={renderOptions}
        value={selectedOption}
        filterOptions={filterOptions}
        onChange={onSelectChange}
        isOptionEqualToValue={(option, value) => {
          if (!value) return false;
          return String(option.value) === String(value.value ?? value);
        }}
        getOptionLabel={(option) => option ? (option.label || String(option)) : ''}
        renderInput={(params) => (
          <TextField
            InputProps={{ ...params.InputProps, type: 'search' }}
            placeholder={props.column_name === 'zip_code' ? (loading ? 'Loading zip codes...' : `Select ${props.element_name} Option`)
              : props.column_name === 'city' ? (loading ? 'Loading cities...' : `Select ${props.element_name} Option`)
                : `Select ${props.element_name} Option`}
            label={props.element_name}
            {...params}
            name={props.column_name}
            variant="outlined"
            error={!!errors[props.column_name]}
          />
        )}
      />
      <FormHelperText>{errors[props.column_name] ? `${props.element_name} is ` + errors[props.column_name] : ''}</FormHelperText>
    </Form.Group>
  );
}
// ...existing code...
// ...existing code...
const DropDownField_o = (props, errors, handleChange, values) => {

  const options = Object.entries(props.option_values).map(([value, label], index) => (
    <option key={index} value={value} label={label} />
  ));
  return <Form.Group className="mb-3 form-group w-full">
    <Form.Label>{props.element_name}<span className={(props.is_require == 1 ? 'required' : 'optional')}>*</span></Form.Label>
    <Form.Select className="form-select" aria-label={props.element_name} name={props.column_name} value={values.state} onChange={handleChange} isInvalid={!!errors[props.column_name]}>
      <option>Select {props.element_name} Option</option>
      {options}
    </Form.Select>
    <Form.Control.Feedback type="invalid">
      {errors[props.column_name]}
    </Form.Control.Feedback>
  </Form.Group>
}




// ...existing code...
const DateField = (props, errors, handleChange, values, setFieldValue) => {
  return <Form.Group className="mb-3 form-group">
    <Form.Label>{props.element_name}<span className={(props.is_require == 1 ? 'required' : 'optional')}>*</span></Form.Label>
    {Object.entries(props.option_values || {}).map((option, index) => {
      return <React.Fragment key={props.field_id + '-' + index}>
        <DatePicker className="form-control w-1/2"
          dateFormat="yyyy.MM.dd"
          name={props.column_name}
          onChange={val => {
            setFieldValue(
              props.column_name,
              `${val.getFullYear()}-${val.getMonth() + 1}-${val.getDate()}`
            )
          }}
          error={!!errors[props.column_name]}
          selected={values[props.column_name] && new Date(values[props.column_name])}
          required
        />

      </React.Fragment>
    })}

  </Form.Group>
}

const ComponentMapping = {
  1: InputBox,
  2: CheckBoxField,
  3: RadioBoxField,
  4: DropDownField,
  5: DateField
}

export default StepperForm
